// src/components/desk/RemovalReason.jsx - "why is this advert removed?" (owner 2026-10-28: "when agent pressed delete the
// listing ... answer why" - rented or sold / not want to work on this anymore / owner asks to delete / owner asked: exclusive
// with another agent / owner asked: no reshares / other). Replaces the plain confirm() of every removal button; the server
// (POST /api/core/ad-takedown, core 4017) refuses a removal without a reason and applies what the reason means.
//
// askRemovalReason(n) mounts its own small dialog on <body> and resolves { reason, note } - or null when cancelled - so a
// caller deep inside a big modal needs no layout change, exactly like the confirm() it replaces.
import { useState } from 'react'
import { createRoot } from 'react-dom/client'
import { t } from '../../lib/i18n.js'

export const REMOVAL_REASONS = ['sold_rented', 'agent_stopped', 'owner_asked', 'owner_exclusive_other', 'owner_no_reshare', 'other']

function ReasonDialog({ n, onDone }) {
  const [reason, setReason] = useState(null)
  const [note, setNote] = useState('')
  const needNote = reason === 'other' && !note.trim()
  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40 p-4" role="dialog" aria-modal="true"
         aria-label={t('desk_adrm_why_title')} onKeyDown={e => { if (e.key === 'Escape') onDone(null) }}>
      <div className="w-full max-w-sm rounded-lg bg-background text-foreground border border-border shadow-lg p-4 text-sm">
        <h3 className="font-semibold mb-1">{t('desk_adrm_why_title')}</h3>
        <p className="text-xs text-muted-foreground mb-2">{t('desk_adrm_confirm').replace('{n}', String(n))}</p>
        <div className="space-y-1.5">
          {REMOVAL_REASONS.map(r => (
            <label key={r} className="flex items-start gap-2 cursor-pointer">
              <input type="radio" name="sntv-removal-reason" className="mt-0.5" checked={reason === r} onChange={() => setReason(r)} />
              <span>{t(`desk_adrm_why_${r}`)}</span>
            </label>
          ))}
        </div>
        {reason && (
          <textarea className="mt-2 w-full rounded-md border border-input bg-background px-2 py-1 text-sm" rows={2} maxLength={300}
            placeholder={t(reason === 'other' ? 'desk_adrm_why_note_required' : 'desk_adrm_why_note')} value={note}
            onChange={e => setNote(e.target.value)} autoFocus={reason === 'other'} />
        )}
        <div className="flex justify-end gap-2 mt-3">
          <button type="button" className="rounded-md px-3 py-1.5 border border-border hover:bg-muted" onClick={() => onDone(null)}>
            {t('desk_adrm_why_cancel')}
          </button>
          <button type="button" disabled={!reason || needNote}
            className="rounded-md px-3 py-1.5 bg-red-600 text-white disabled:opacity-40"
            onClick={() => onDone({ reason, note: note.trim() })}>
            {t('desk_adrm_why_remove')}
          </button>
        </div>
      </div>
    </div>
  )
}

export function askRemovalReason(n = 1) {
  return new Promise(resolve => {
    const host = document.createElement('div')
    document.body.appendChild(host)
    const root = createRoot(host)
    const done = v => { root.unmount(); host.remove(); resolve(v) }
    root.render(<ReasonDialog n={n} onDone={done} />)
  })
}
